var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282D2D",
    stroke: "#282D2D",
    strokeWidth: 0.3,
    d: "M26 4.85h-2.85V1.5a.65.65 0 0 0-.2-.45.65.65 0 0 0-.45-.2h-1c-.407 0-.65.33-.65.65v3.35H9.15V1.5a.65.65 0 0 0-.2-.45.65.65 0 0 0-.45-.2h-1c-.407 0-.65.33-.65.65v3.35H4A3.15 3.15 0 0 0 .85 8v22c0 1.77 1.38 3.15 3.15 3.15h22A3.15 3.15 0 0 0 29.15 30V8c0-1.708-1.442-3.15-3.15-3.15ZM26.85 30c0 .474-.427.85-.85.85H4c-.48 0-.85-.37-.85-.85V13.15h23.7zm0-19.15H3.15V8c0-.423.376-.85.85-.85h22c.201 0 .415.102.581.269.167.166.269.38.269.581zM8 25.15h6c.577 0 1.15-.499 1.15-1.15v-6c0-.299-.148-.585-.356-.794-.209-.208-.495-.356-.794-.356H8c-.651 0-1.15.573-1.15 1.15v6c0 .645.505 1.15 1.15 1.15Zm1.15-6h3.7v3.7h-3.7z"
  })));
};
export default SvgCalendar;